export const PRIVATE_MODULES_PATH = {
  USERS: "user",
  PROFILE: "profile",
  LOGOUT: "logout",
  TOOLS: "tools",
  OWNERS: "owners",
  PROPERTY: "realestates",
  agencies: "agencies",
  MORTGAGE_REFERENCE: "mortgage-reference",
  REPORT: "reports",
  COMPONENTS: "components"
};
